export default "__VITE_ASSET__Dh1k2f4j__"